module.exports = __webpack_public_path__ + "static/media/Illus-Bowl.d442b944.png";